import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "stepper" };
const _hoisted_2 = { class: "stepper-title" };
import UTooltip from "@/components/uikit/uComponents/UTooltip.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UTextStepper',
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "stepper-item"
                    }, [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(item.title), 1),
                        _createTextVNode(" — " + _toDisplayString(item.text) + " ", 1),
                        (item.tooltip)
                            ? (_openBlock(), _createBlock(UTooltip, {
                                key: 0,
                                tooltip: item.tooltip
                            }, null, 8, ["tooltip"]))
                            : _createCommentVNode("", true)
                    ]));
                }), 128))
            ]));
        };
    }
});
